//
// Copyright (c) 2011-2019 by Curalate, Inc.
//
import { ISystemAlertDto } from '@apis/system-alerts/systemAlertsApiModels';
import { crl8 } from 'app/curalate.globals';

export class Alert implements ISystemAlertDto {

  public static fromDto(alertDto: ISystemAlertDto) {
    return new Alert(
      alertDto.message,
      alertDto.linkText,
      alertDto.linkTarget,
      alertDto.trackingId,
    );
  }

  public isDismissed: boolean;
  private readonly isDismissable: boolean;

  constructor(
    public readonly message: string,
    public readonly linkText?: string,
    public readonly linkTarget?: string,
    public readonly trackingId?: string,
  ) {
    this.isDismissable = !!this.trackingId;
    this.isDismissed = this.isDismissable && localStorage.getItem(this.getDismissKey()) === 'dismissed';
  }

  public getViewCount(): number {
    if (!this.trackingId) {
      return -1;
    }
    const value = parseInt(localStorage.getItem(this.getViewCountKey()), 10);
    return isNaN(value) ? 0 : value;
  }

  // Increments view count in local storage, returns the new view count
  public incrementViewCount(): number {
    if (!this.trackingId) {
      return -1;
    }
    const newViewCount = this.getViewCount() + 1;
    localStorage.setItem(this.getViewCountKey(), newViewCount.toString());
    return newViewCount;
  }

  public dismiss() {
    if (this.isDismissable) {
      // Potential expansion: Specify UserId or ClientId to scope the change.
      localStorage.setItem(this.getDismissKey(), 'dismissed');
      this.isDismissed = true;
    }
  }

  private getViewCountKey() {
    return `system.alert.views:${crl8.session.user.id}:${this.trackingId}`;
  }

  private getDismissKey() {
    return `system.alert.dismissed:${crl8.session.user.id}:${this.trackingId}`;
  }
}
